import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

import { AuthComponent } from './auth/auth.component';
import { SecuredComponent } from './secured/secured.component';

const routes: Routes = [
  {
    // Veřejná (nepřihlášená) "tajná" stránka pro trenéry - zadání požadavku na přestup.
    // Mimo /secured i /auth - žádný app chrome, žádný AuthGuard. :token nese tajný přístupový token,
    // který si ověřuje až backend (viz PublicTransferRequestsController) - špatný token => "Nenalezeno".
    path: 'r/:token',
    loadChildren: () => import('./public/public.module').then(m => m.PublicModule)
  },
  {
    path: 'auth',
    component: AuthComponent,
    children: [
      { path: 'login', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) },
      { path: '', redirectTo: 'login', pathMatch: 'full' }
    ]
  },
  { 
    path: 'secured', 
    component: SecuredComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'transfers', loadChildren: () => import('./features/transfers/transfers.module').then(m => m.TransfersModule) },
      { path: 'clubs', loadChildren: () => import('./features/clubs/clubs.module').then(m => m.ClubsModule) },
      { path: 'players', loadChildren: () => import('./features/players/players.module').then(m => m.PlayersModule) },
      { path: 'assistant', loadChildren: () => import('./features/assistant/assistant.module').then(m => m.AssistantModule) },
      { path: 'proposals', redirectTo: 'assistant/proposals', pathMatch: 'full' },
      { path: 'users', loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule) },
      { path: 'knowledge', loadChildren: () => import('./features/knowledge/knowledge.module').then(m => m.KnowledgeModule) },
      { path: 'price-tables', loadChildren: () => import('./features/price-tables/price-tables.module').then(m => m.PriceTablesModule) },
    ]
  },
  { path: '', redirectTo: 'secured', pathMatch: 'full' },
  { path: '**', redirectTo: 'secured' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
